import {BrandAndMarketListItem, PreferenceRule} from '../../../integrated-client/models';

export interface IBrandAndMarket {
  brandAndMarket: BrandAndMarketListItem | null
}

export interface IProviderPreferenceEditorData {
  preferenceData?: PreferenceRule & IBrandAndMarket
  validation?: any
}
export class ProviderPreferenceEditorData implements IProviderPreferenceEditorData {

  preferenceData?: PreferenceRule & IBrandAndMarket
  validation?: any
}
